import { z } from "zod";
import i18n from "../config/i18n";
import { VALIDATION } from "../config/constants";

const t = (key: string) => i18n.t(key);

const validEmailDomain = (_email: string) => true;
const PHONE_REGEX = /^\+?[0-9\-\s()]{7,20}$/;

export const getRegisterSchema = () =>
  z
    .object({
      firstName: z
        .string()
        .min(2, t("validation.firstNameLength"))
        .max(50, t("validation.firstNameLength")),
      lastName: z
        .string()
        .min(2, t("validation.lastNameLength"))
        .max(50, t("validation.lastNameLength")),
      email: z
        .string()
        .min(1, t("validation.emailRequired"))
        .email(t("validation.emailInvalid"))
        .refine(validEmailDomain, {
          message: t("validation.emailInvalid"),
        }),
      password: z
        .string()
        .min(VALIDATION.PASSWORD_MIN_LENGTH, t("validation.passwordMin")),
      phoneNumber: z
        .string()
        .min(1, t("validation.phoneRequired"))
        .regex(PHONE_REGEX, t("validation.phoneInvalid")),
    });

/** @deprecated Use getRegisterSchema() for i18n support */
export const registerSchema = getRegisterSchema();
export type RegisterFormData = z.infer<ReturnType<typeof getRegisterSchema>>;

// Enhanced validation schema for Google registration
export const getGoogleRegistrationSchema = () =>
  z.object({
    email: z.string().email(t("validation.emailInvalid")),
    firstName: z.string().min(1, t("validation.firstNameRequired")),
    lastName: z.string().min(1, t("validation.lastNameRequired")),
    phoneNumber: z
      .string()
      .min(10, t("validation.phoneMin"))
      .regex(PHONE_REGEX, t("validation.phoneInvalid")),
    acceptTerms: z
      .boolean()
      .refine((val) => val === true, t("validation.acceptTerms")),
    referralCode: z.string().max(20).optional().or(z.literal("")),
  });

/** @deprecated Use getGoogleRegistrationSchema() for i18n support */
export const googleRegistrationSchema = getGoogleRegistrationSchema();
export type GoogleRegistrationFormData = z.infer<
  ReturnType<typeof getGoogleRegistrationSchema>
>;
